<div class="mt-5">
  <h3 class="mat-h3">Studies</h3>
  <app-common-table [params]="getTableParams()"></app-common-table>
</div>
